import React from 'react'
import PropTypes from 'prop-types'

import SubText from '@components/text/subText'
import colors from '@settings/styleSettings'

const Label = ({
  style, label, required, error
}) => (
  <SubText style={{
    ...style, color: error ? colors.strongRed : colors.strongGray, display: 'flex', gap: '5px'
  }}
  >
    {label}
    {required && <SubText style={{ color: colors.strongRed }}> *</SubText>}
  </SubText>
)

Label.propTypes = {
  style: PropTypes.shape({}),
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
}

Label.defaultProps = {
  style: null,
  required: false,
  error: false,
}

export default Label
